import { useMutation, useQueryClient } from "@tanstack/react-query";
import { showErrorAlert } from "../../utils/showErrorAlert";
import { showSuccessToast } from "../../utils/showToastAlert";

/**
 * @param {object} deps
 * @param {(url: string, options: any) => Promise<any>} deps.callApiWithWorker
 * @param {(path: string) => void} deps.navigate
 * @param {(key: string) => string} deps.t
 */
export function usePostDistribution({ callApiWithWorker, t }) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ["createDistribution"],
    mutationFn: async (payload) => {
      return callApiWithWorker(`/distributions`, {
        method: "POST",
        body: payload,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["distributions"] });

      showSuccessToast(t("createdSubMessage", "Creation successfully"), {
        title: t("createdMessage", "Distribución creada"),
      });
    },
    onError: (error) => {
      console.error("Error al crear la distribución:", error);
      showErrorAlert(error);
    },
  });
}
